// Financial calculations for Legatum Coffee admin
// Wompi Colombia commission: 2.65% + $700 fixed + 19% IVA over the commission
// Reference: https://docs.wompi.co

const WOMPI_PERCENT = 0.0265;   // 2.65%
const WOMPI_FIXED = 700;         // $700 COP
const IVA_RATE = 0.19;           // 19% IVA over the commission

/**
 * Calculate Wompi gateway cost for a given total (in COP).
 * Returns rounded to nearest peso.
 */
export const calcGatewayCost = (total) => {
  if (!total || total <= 0) return 0;
  const commissionBase = total * WOMPI_PERCENT + WOMPI_FIXED;
  const iva = commissionBase * IVA_RATE;
  return Math.round(commissionBase + iva);
};

/**
 * Calculate net income after gateway cost and shipping.
 */
export const calcNetIncome = (total, shippingCost) => {
  const gateway = calcGatewayCost(total);
  const shipping = shippingCost || 0;
  return Math.round((total || 0) - gateway - shipping);
};

/**
 * Full financial breakdown for an order.
 */
export const calcOrderFinancials = (order) => {
  const total = order?.total || 0;
  const shipping = order?.shipping_cost || 0;
  const subtotal = order?.subtotal || 0;
  const gateway = calcGatewayCost(total);
  const net = Math.round(total - gateway - shipping);
  return {
    subtotal,
    shipping,
    gateway,
    net,
    total,
  };
};
